import React from 'react';
import { WithTranslation } from 'react-i18next';
import LoaderIcon from 'components/LoaderImage';
import LogoIcon from 'components/LogoImage';
import { ROUTES } from 'constants/routes';
import { defaultCriticalErrorProps } from 'constants/errorProps';
import ErrorLayoutCommon from '#web-components/components/Layouts/Error';
import { getRegistryTitle, getRegistryTitleFull } from '#shared/utils/registrySettings';
import ErrorNavLink from './components';

type ErrorBoundaryProps = WithTranslation;

const registryTitle = getRegistryTitle(REGISTRY_SETTINGS);
const registryTitleFull = getRegistryTitleFull(REGISTRY_SETTINGS);

export default class ErrorBoundary extends React.Component<ErrorBoundaryProps> {
  state = {
    hasError: false,
  };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  // eslint-disable-next-line class-methods-use-this
  handleBackLinkClick = (path?: string) => {
    window.location.assign(path || ROUTES.PROCESS_LIST);
  };

  render() {
    const { hasError } = this.state;
    const { children, t, i18n } = this.props;

    if (hasError) {
      return (
        <ErrorLayoutCommon
          t={i18n.getFixedT(i18n.language, 'domains')}
          registryName={registryTitle}
          registryFullName={registryTitleFull}
          error={defaultCriticalErrorProps}
          reloadButtonCaption={t('errorLayout.reloadPage')}
          defaultErrorTitle={t('errorLayout.errorTitle')}
          defaultBackLinkTitle={t('errorLayout.backToHome')}
          defaultMessage={t('errorLayout.smthWentWrong')}
          defaultDescription={t('errorLayout.reloadPageAndContactAdministrator')}
          homePath={ROUTES.PROCESS_LIST}
          navLinkComponent={ErrorNavLink}
          appTitle={t('text:appTitle')}
          onBackLinkClick={this.handleBackLinkClick}
          loaderIcon={<LoaderIcon />}
          logoIcon={<LogoIcon />}
          supportChannelUrl={REGISTRY_ENVIRONMENT_VARIABLES.supportChannelUrl}
        />
      );
    }
    return children;
  }
}
